<template>
  <LoadingSpinner v-if="loading" />
  <div :id="ELEMENT_ID" />
</template>

<script setup lang="ts">
import { capturePaypalPayment, createPaypalOrder } from '~/helpers/http';
import type { VisaForm } from '~/types';

const ELEMENT_ID = 'paypal-button-container';
const CLIENT_ID = useRuntimeConfig().public.paypalClientId;

const props = defineProps<{
  form: VisaForm;
}>();

const router = useRouter();
const { currency } = useBranch();
const { buildSuccessRoute } = useRouting();

const loading = ref(true);

load();

onActivated(() => {
  if (window.paypal) setButtons();
});

function load() {
  if (window.paypal) return;
  useHead({
    script: [{
      src: `https://www.paypal.com/sdk/js?client-id=${CLIENT_ID}&currency=${currency.toUpperCase()}`,
      async: true,
      defer: true,
      onload: setButtons,
      crossorigin: 'anonymous'
    }]
  });
}

function setButtons() {
  const payload = { form: props.form, currency };
  window.paypal.Buttons({
    createOrder: () => createPaypalOrder(payload).then(({ id }) => id),
    onApprove: async (data: any) => {
      await capturePaypalPayment({ id: data.orderID, formId: props.form.id });
      router.push(buildSuccessRoute(props.form.id, props.form.product.country, 'paypal'));
    }
  }).render(`#${ELEMENT_ID}`);
  loading.value = false;
}
</script>

<style scoped>
#paypal-button-container {
  margin: 0 auto;
  max-width: 750px;
}
</style>